import * as React from 'react';
import { Button, Card, CardActions, CardContent, CardMedia, createTheme, ThemeProvider, Typography } from '@mui/material';
import SvgIcon from "@material-ui/core/SvgIcon";
import DienThoai from '../assets/DienThoai.svg';
import { PureComponent } from "react";
const theme = createTheme({

	components: {
		MuiCardContent: {
			styleOverrides: {
				root: {
					padding: "8px 2px 8px 20px"
				}
			}
		},
		MuiCard: {
			styleOverrides: {
				root: {
					justifyContent: "center",
					textAlign: "center",
					alignContent: "center",
					alignSelf: "center",

				}
			}
		},
		MuiCardMedia: {
			styleOverrides: {
				root: {
					paddingTop: "10px",
					justifyContent: "center",
					objectFit: "inherit",
					position: "static"
				}
			}
		},
		MuiCardActions: {
			styleOverrides: {
				root: {
					textAlign: "center",
					justifyContent: "center",
					alignItems: "center",
					padding: 0
				}
			}
		},

		MuiButton: {
			styleOverrides: {
				root: {
					fontSize: "10px",
					lineHeight: "15px",
					height: "20px",
					borderRadius: "15px",
					backgroundColor: "var(--color-primary)",
					":hover": {
						backgroundColor: "#2f9c2f",
					},
					position: "static"
				}
			}
		}
	},
	// typography: {
	// 	body1: {
	// 		fontWeight: 700,
	// 		color: palette.secondary[0],
	// 	},
	//
	// },
})
const mediaInline = {
	left: "10px",
	// top: "50%",
	// transform: "translateY(-50%)",
	position: "static",
	paddingTop: 0
}
export default function MediaCard({ isSVG, imagePath, title, description, btnAction, btnText, Image, ...rest }) {
	return (
		<ThemeProvider theme={theme}>
			<Card style={{ ...rest.style, textAlign: rest.isInline ? "left" : "center" }}>
				<div style={{ margin: "auto", width: "30%" }}>
					<CardMedia
						sx={{
							pl: 1
						}}
						style={rest.isInline ? { ...mediaInline, width: rest.imgWidth ? rest.imgWidth : "100%" } : {}}
						component={"img"}
						height={rest.isInline ? "80%" : "90px"}
						src={Image ? Image : imagePath}
						width={"50px"}
						alt={rest.alt ? rest.alt : ""}
					/>
				</div>
				<div style={{ margin: "auto 0", width: "70%" }}>
					<CardContent style={{ padding: !rest.isInline ? "16px" : "8px 2px 8px 2px" }}>
						<Typography className={"headTitle"}>
							{title ? title : ""}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{description ? description : ""}
						</Typography>
					</CardContent>
					<CardActions>
						{
							btnAction &&
							<Button size="small" onClick={btnAction} variant={"contained"}>{btnText}</Button>
						}
					</CardActions>
				</div>


			</Card>
		</ThemeProvider>


		// <Card adjustsFontSizeToFit className={classes.root}>
		// 	<CardContent>
		// 		<Typography color="textSecondary" >
		// 			{title ? title : ""}
		// 		</Typography>
		// 		<Typography variant="body2" component="p">
		// 			{description ? description : ""}
		// 		</Typography>
		// 	</CardContent>
		// 	<CardActions>
		// 		{
		// 			btnAction &&
		// 			<Button size="small" onClick={btnAction} variant={"contained"}>{btnText}</Button>
		// 		}
		// 	</CardActions>
		// </Card>
	);
}
